import PageLayout from "../components/pageLayout";
import DepartmentsList from "../components/DepartmentsList";

function DepartmentsListPage() {
  return <PageLayout children={<DepartmentsList />} />;
}

export default DepartmentsListPage;
